import { Button, Stack, useTheme } from '@mui/material'
import Avatar from '@mui/material/Avatar'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import type { MouseEvent } from 'react'

import type { UserInfo } from '../types/auth'

export interface UserMenuProps {
  cognitoUser?: UserInfo
  anchorElUser: HTMLElement | null
  handleOpenUserMenu: (event: MouseEvent<HTMLElement>) => void
  handleCloseUserMenu: (event: MouseEvent<HTMLElement>) => void
  handleLogout?: () => void
}

export default function UserMenu({
  cognitoUser,
  anchorElUser,
  handleOpenUserMenu,
  handleCloseUserMenu,
  handleLogout,
}: UserMenuProps) {
  const theme = useTheme()

  if (cognitoUser) {
    return (
      <div>
        <Tooltip title={'User Menu'}>
          <IconButton onClick={handleOpenUserMenu} sx={{ p: 0, marginRight: '5px' }}>
            <UserAvatar cognitoUser={cognitoUser} />
          </IconButton>
        </Tooltip>
        <Menu
          sx={{ zIndex: theme.zIndex.drawer + 1 }}
          id="menu-appbar"
          anchorEl={anchorElUser}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'center',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={Boolean(anchorElUser)}
          onClose={handleCloseUserMenu}
        >
          <Stack p={2} alignItems={'center'} spacing={1.5} sx={{ minWidth: 200 }}>
            <UserAvatar cognitoUser={cognitoUser} />
            <Stack alignItems={'center'}>
              {cognitoUser.attributes?.name && <Typography fontSize={14}>{cognitoUser.attributes?.name}</Typography>}
              {cognitoUser.attributes?.email && <Typography fontSize={12}>{cognitoUser.attributes?.email}</Typography>}
            </Stack>
            {handleLogout && (
              <Button variant="outlined" onClick={handleLogout}>
                Sign Out
              </Button>
            )}
          </Stack>
        </Menu>
      </div>
    )
  }

  return <UserAvatar cognitoUser={cognitoUser} />
}

interface UserAvatarProps {
  cognitoUser?: UserInfo
}

function UserAvatar({ cognitoUser }: UserAvatarProps) {
  if (cognitoUser?.attributes) {
    return <Avatar alt={cognitoUser.attributes?.name} src={cognitoUser.attributes?.picture} />
  }

  return <Avatar alt="Veho" />
}
